module.exports = __webpack_public_path__ + "img/LogoInfonavitBlanco.6bf7a7d7.png";